module.exports = __webpack_public_path__ + "media/images/icon-notification@3x-7ad9eb2e3b8bdc877e10cfc12da11ee4.png";